module.exports = __webpack_public_path__ + "img/PhoenixArtwork.4f51696b.png";